export default __webpack_public_path__ + "static/media/ws.765aecca.svg";